import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import styled from "styled-components";
import TabContainer from "../tab/TabContainer";
import AddButtonFullText from "../buttons/AddButtonFullText";
import InputSearch from "../inputs/InputSearch";
import ActionModal from "../modal/action/ActionModal";
import useFilterUser from "../../custom-hooks/useFilterUser";
import {DisplayForHead} from "../../permissions/DisplayAccordingToRole";
import {IS_HEAD} from "../../permissions/roleTypes";
import PilotsSearchBar from "../search-bar/by-pilot/PilotsSearchBar";
import ActionsList from "./ActionsList";
import SearchBarByTag from "../search-bar/SearchBarByTag";
import SearchBarByAdvancement from "../search-bar/by-advancement/SearchBarByAdvancement";
import SearchBarByCriticality from "../search-bar/SearchBarByCriticality";
import {removeDuplicatesInArray} from "../../utils/utils";
import SearchByAxis from "../search-bar/SearchByAxis";
import useTab from "../../custom-hooks/useTab";
import useSearchBar from "../../custom-hooks/useSearchBar";
import {
    ADVANCEMENT_FILTER,
    AXIS_FILTER,
    CRITICALITY_FILTER,
    FINISH_FILTER,
    INPROGRESS_FILTER,
    PILOT_FILTER,
    PILOTS_FILTER,
    TAGS_FILTER
} from "../tab/filterTypes";
import SearchActionsByDate from "../search-bar/by-date/SearchActionsByDate";


const Actions = ({
                     projectId = 0,
                     actions,
                     inActionPage,
                 }) => {

    const currentUser = useSelector(state => state.currentUser)
    const {pilot, copilot, axisSponsor} = useSelector(state => state.project)

    const [isOpenModal, setOpenModal] = useState(false)
    const [selectedActionId, setSelectedActionId] = useState(0)
    const [sectionsMenu, setSectionsMenu] = useState([])
    const [actionsDisplayed, setActionsDisplayed] = useState([])
    const [allPilots, setAllPilots] = useState([])
    const [numberOfActions, setNumberOfActions] = useState(0)
    const {sections, toggleSection, activeTab} = useTab(sectionsMenu)
    const {filter, setFilter} = useSearchBar()
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    useEffect(() => {
        let selectedSection = sections.filter(s => s.state === true)[0] || {}
        if (Object.keys(selectedSection).length > 0) {
            setFilter(selectedSection.key)
        }
    }, [sections, setFilter])

    useEffect(() => {
        let menu = []
        const canDisplayAllTabs = IS_HEAD(currentUser.roles) || projectId !== 0
        menu.unshift({key: FINISH_FILTER, label: "Terminées", state: false,})
        menu.push({key: PILOT_FILTER, label: "Mes actions", state: !(canDisplayAllTabs),})
        menu.push({key: CRITICALITY_FILTER, label: "Par criticité", state: false,})
        menu.push({key: ADVANCEMENT_FILTER, label: "Par avancement", state: false,})
        if (canDisplayAllTabs) {
            menu.unshift({key: INPROGRESS_FILTER, label: "En cours", state: true,})
            menu.push({key: TAGS_FILTER, label: "Par tag", state: false,})
            menu.push({key: PILOTS_FILTER, label: "Par pilote", state: false,})
        }
        if (inActionPage) {
            menu.push({key: AXIS_FILTER, label: "Par axe", state: false,})
            //menu.push({key: PROJECTS_FILTER, label: "Par projet",state: false,})

        }
        setSectionsMenu(menu)
    }, [currentUser.roles, inActionPage, projectId])

    useEffect(() => {
        if (filter === PILOT_FILTER) {
            setActionsDisplayed(actions.filter(p => p[filter]?.id === currentUser.id))
        }
        if (filter === INPROGRESS_FILTER) {
            setActionsDisplayed(actions.filter(element => element.advancement !== 100))
        }
        if (filter === FINISH_FILTER) {
            setActionsDisplayed(actions.filter(element => element.advancement === 100))
        }
        if (!inActionPage) {
            setActionsDisplayed(actions)
        }
    }, [actions, currentUser.id, filter, inActionPage])

    useEffect(() => {
        const allPilotsByActions = actions.map(p => p.pilot)
        const allExistingPilots = allPilotsByActions.filter(p => p.firstName !== "Deleted")
        setAllPilots(allExistingPilots)
    }, [actions])

    const addNewAction = (state, id) => {
        if (id === 0 && state === true) {
            setOpenModal(true)
        } else {
            setOpenModal(isOpenModal)
        }
    }
    const displayModal = () => {
        if (isOpenModal) {
            return (
                <ActionModal
                    setOpenModal={setOpenModal}
                    selectedActionId={selectedActionId}
                    inActionPage={inActionPage}
                />


            )
        }
    }


    const displayFilters = (filter) => {
        if (filter === CRITICALITY_FILTER) {
            return (
                <SearchBarByCriticality
                    data={actions}
                    setData={setActionsDisplayed}
                />

            )
        }
        if (filter === PILOTS_FILTER) {
            return (
                <PilotsSearchBar
                    setData={setActionsDisplayed}
                    data={actions}
                    usersArray={removeDuplicatesInArray(allPilots)}
                />
            );
        }
        if (filter === TAGS_FILTER) {
            return (
                <SearchBarByTag
                    setData={setActionsDisplayed}
                    data={actions}
                />
            )
        }
        if (filter === ADVANCEMENT_FILTER) {
            return (
                <SearchBarByAdvancement
                    setData={setActionsDisplayed}
                    data={actions}
                />
            )
        }
        if (filter === AXIS_FILTER) {
            return (
                <SearchByAxis
                    data={actions}
                    setData={setActionsDisplayed}
                    inActionPage={inActionPage}
                />
            )
        }
        if (filter === INPROGRESS_FILTER || filter === FINISH_FILTER) {
            return (<SubFilterContainer>
                <SearchActionsByDate
                    setData={setActionsDisplayed}
                    data={actions}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    isSetByAdvancement={false}/>

            </SubFilterContainer>)
        }
    }
    const {
        query,
        setQuery
    } = useFilterUser(actions)

    const hasException = () => {
        return (pilot ? pilot.id === currentUser.id : false) || (copilot ? copilot.id === currentUser.id : false) || (axisSponsor ? axisSponsor.id === currentUser.id : false)
    }
    return (
        <Container>
            {displayModal()}
            <DisplayForHead
                hasException={hasException()}
                component={<AddButtonFullText
                    setId={setSelectedActionId}
                    setUpdate={addNewAction}
                    title={"Ajouter une action"}
                />}
            />
            {
                inActionPage &&
                <InputSearch
                    setQuery={setQuery}
                    placeholder={"nom de l'action, pilote, projet..."}
                />
            }

            {sections.length > 0 && inActionPage &&
                <TabContainer
                    children={sections}
                    selectedTab={activeTab}
                    toggleSection={toggleSection}
                />
            }

            {   inActionPage &&
                displayFilters(filter)
            }

            <p><Span>{numberOfActions} </Span> action{numberOfActions > 1 ? "s" : ""}</p>

            <ActionsList
                actions={actionsDisplayed}
                query={query}
                inActionPage={inActionPage}
                setNumberOfActions={setNumberOfActions}
            />


        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  gap: 1.5rem;

  h1 {
    width: 100%;
    text-align: center;

  }

  @media (min-width: 900px) {
    width: 100%;
    justify-content: space-around;
  }
`
const Span = styled.span`
  font-weight: 800;
  color: var(--color-purple);
  font-size: 150%;

  @media (min-width: 900px) {
    font-size: 200%;
  }

`
const SubFilterContainer = styled.div`  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
`

export default Actions;